import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import 'components/PropertyImageGallery/PropertyImageGallery.scss';
import InlineGallery from 'components/InlineGallery';
import ImageGalleryModal from 'components/ImageGalleryModal';
import {presetDimensions} from 'components/imaging/ResizedDasWebImage';

const PropertyImageGallery = (
  {
    currentIndex,
    deletableImages,
    hasModal,
    images,
    inlineGalleryProps,
    isLoading,
    modalProps,
    objectContext,
    pageContext,
    property,
    resizeProps,
    onFetchPropertyPhotos,
    onIndexChange,
    onDelete,
    onUpload,
  }
) => {
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    if (!hasFetched && property?.singleLineAddress) {
      if (isLoading) {
        onFetchPropertyPhotos();
      }
      setHasFetched(true);
    }
  }, [isLoading, hasFetched, property?.singleLineAddress]);

  function renderInlineGallery() {
    return (
      <InlineGallery
        fetched={!isLoading && hasFetched}
        images={images}
        resizeProps={resizeProps}
        currentIndex={currentIndex}
        onIndexChange={onIndexChange}
        deletableImages={deletableImages}
        onUpload={onUpload}
        onDelete={onDelete}
        {...inlineGalleryProps}
      />
    );
  }

  function renderFullGallery() {
    return (
      <ImageGalleryModal
        fetched={hasFetched}
        pageContext={pageContext}
        objectContext={objectContext}
        images={images}
        currentIndex={currentIndex}
        onIndexChange={onIndexChange}
        trigger={renderInlineGallery()}
        {...modalProps}
      />
    );
  }

  return hasModal
    ? renderFullGallery()
    : renderInlineGallery();
};

PropertyImageGallery.propTypes = {
  currentIndex: PropTypes.number,
  deletableImages: PropTypes.arrayOf(PropTypes.string),
  hasModal: PropTypes.bool,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  inlineGalleryProps: PropTypes.object,
  isLoading: PropTypes.bool,
  modalProps: PropTypes.object,
  objectContext: PropTypes.string,
  pageContext: PropTypes.string,
  property: PropTypes.shape({
    singleLineAddress: PropTypes.string,
  }),
  resizeProps: PropTypes.shape({
    isResize: PropTypes.bool,
    resizeDimensions: PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
    }),
  }),
  onFetchPropertyPhotos: PropTypes.func.isRequired,
  onIndexChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onUpload: PropTypes.func,
};

PropertyImageGallery.defaultProps = {
  currentIndex: 0,
  deletableImages: [],
  hasModal: true,
  inlineGalleryProps: undefined,
  isLoading: true,
  modalProps: undefined,
  objectContext: 'Image Gallery',
  pageContext: 'Image Gallery',
  property: {},
  resizeProps: presetDimensions.PROPERTY_MEDIUM,
};

export default PropertyImageGallery;
